<template>
  <div class="time-picker d-s-s w-100">
    <!-- element 选择开始时间和结束时间 -->
    <el-form :model="formInline" size="mini" label-width="100px">
      <el-form-item label="开始日期">
        <el-date-picker v-model="formInline.startTime" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd"
          @change="changeTime" />
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker v-model="formInline.endTime" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd"
          @change="changeTime" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

function changeTime() {
  if (this.formInline.startTime > this.formInline.endTime) {
    return this.$message.warning('开始时间要小于结束时间')
  }
  if (this.formInline.startTime && this.formInline.endTime) {
    // console.log(`${this.formInline.startTime}&${this.formInline.endTime}`)
    this.$emit('changeTime', `${this.formInline.startTime}&${this.formInline.endTime}`)
  } else {
    console.log('请选择时间')
  }
}

export default {
  name: "TimePicker",
  props: {

  },
  data() {
    return { formInline: { startTime: '', endTime: '' } }
  },
  methods: {
    changeTime
  },
  created() { }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/weipai/TimePicker.vue